import React, { useContext } from 'react';
import { FilterBarContext, FilterFieldName } from '../FilterBarContext';
import { SelectChangeEvent } from '@mui/material';
import PoSelect from '@/components/inputs/PoSelect';
import { useTranslation } from '@/lib';

interface ListSelectFilterProps<T, V> {
  filterFieldName: FilterFieldName;
  label?: string;
  options: T[];
  renderOption: (item: T) => React.ReactNode;
  valueExtractor: (item: T) => V;
  disabled?: boolean;
}

function ListSelectFilter<T, V>({
  filterFieldName,
  label,
  options,
  renderOption,
  valueExtractor,
  disabled,
}: ListSelectFilterProps<T, V>): JSX.Element {
  const { setFilterValue, filterValues } = useContext(FilterBarContext);
  const { t } = useTranslation();

  function onValueChanged(event: SelectChangeEvent<V>) {
    if (event.target.value === '' || event.target.value === null) {
      setFilterValue(filterFieldName, undefined);
      return;
    }
    setFilterValue(filterFieldName, event.target.value, t((event.target.value as string).toLowerCase()));
  }

  return (
    <PoSelect
      label={label}
      value={filterValues[filterFieldName] as V}
      options={options}
      onChange={onValueChanged}
      renderOption={renderOption}
      valueExtractor={valueExtractor}
      disabled={disabled}
    />
  );
}

export default ListSelectFilter;
